import type {
  SectionChangeHandler,
  SectionType,
} from '@components/SitemapReport/types'
import type React from 'react'

import {
  ReportPageOpenedDeltaEvents,
  ReportPageOpenedEvents,
} from '@/components/SitemapReport/constants'
import { sendGtmEvent } from '@/constants/gtm'

export const useCardItem = (
  section: SectionType,
  count: number,
  onSectionChange: SectionChangeHandler
) => {
  const disabled = count === 0
  const totalAmount = section === 'total'

  const handleDeltaClick = (event: React.MouseEvent) => {
    event.stopPropagation()
    const gtmEvent = ReportPageOpenedDeltaEvents[section]

    if (gtmEvent) {
      sendGtmEvent(gtmEvent)
    }

    onSectionChange(section, true)
  }

  const handleClick = () => {
    if (disabled) {
      return
    }

    const gtmEvent = ReportPageOpenedEvents[section]

    if (gtmEvent) {
      sendGtmEvent(gtmEvent)
    }

    onSectionChange(section)
  }

  return {
    disabled,
    totalAmount,
    handleDeltaClick,
    handleClick,
  }
}
